import React, { useContext, type JSX } from 'react';
import setFavoritUtvalMutationDoc from './setFavoritUrvalMutation.gql';
import {
  SetFavoritUrvalMutation as ISetFavoritUrvalMutationData,
  SetFavoritUrvalMutationVariables as ISetFavoritUrvalMutationVariables,
} from './_QueryTypes/SetFavoritUrvalMutation';
import { useMutation } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../../ActiveDatabaseContext/ActiveDatabaseContext';
import { RutinUrvalListQuery_routineselections } from '../../../../../SavedUrval/Queries/RutinUrvalListQuery/_QueryTypes/RutinUrvalListQuery';

export type SetFavoritUrvalType = (id: string, rutinID: number) => void;

interface IProps {
  children: (setFavoritUrval: SetFavoritUrvalType) => JSX.Element;
}

export const useSetFavoritUrval = (): SetFavoritUrvalType => {
  const [mutateFn] = useMutation<
    ISetFavoritUrvalMutationData,
    ISetFavoritUrvalMutationVariables
  >(setFavoritUtvalMutationDoc);
  const activeDatabaseContext = useContext(ActiveDatabaseContext);

  return (id: string, rutinID: number) => {
    if (activeDatabaseContext.activeDatabase) {
      mutateFn({
        variables: {
          id,
          rutinID,
          dbname: activeDatabaseContext.activeDatabase,
        },
        updateQueries: {
          RutinUrvalListQuery: (prevResult, options) => {
            const typedPrevResult = prevResult as {
              routineselections: RutinUrvalListQuery_routineselections[] | null;
            };
            if (typedPrevResult.routineselections) {
              const newRoutineselections = typedPrevResult.routineselections.map(
                routineSelection => {
                  if (
                    routineSelection.id ===
                    options.mutationResult.data?.setfavoritselection?.id
                  ) {
                    return {
                      ...routineSelection,
                      anvFavorit:
                        options.mutationResult.data?.setfavoritselection
                          ?.anvFavorit,
                    };
                  } else {
                    return { ...routineSelection, anvFavorit: false };
                  }
                }
              );
              return {
                ...typedPrevResult,
                routineselections: newRoutineselections,
              };
            } else {
              return typedPrevResult;
            }
          },
        },
        optimisticResponse: variables => ({
          setfavoritselection: {
            __typename: 'TEDSelection',
            id: variables.id,
            anvFavorit: true,
          },
        }),
      });
    }
  };
};

const SetFavoritUrvalMutation: React.FC<IProps> = props => {
  const setFavoritUrval = useSetFavoritUrval();

  return props.children(setFavoritUrval);
};

export default SetFavoritUrvalMutation;
